import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getBadgeColor = (badgeName: string): string => {
  switch (badgeName) {
    case "Rookie":
      return "bg-blue-600";
    case "Master":
      return "bg-purple-600";
    case "Elite":
      return "bg-green-600";
    case "Captain":
      return "bg-indigo-600";
    case "Veteran":
      return "bg-pink-600";
    case "Boss":
      return "bg-yellow-600";
    case "Legendary":
      return "bg-red-600";
    default:
      return "bg-gray-600";
  }
};
